import { isPlainObject } from 'lodash'

import { SIDEBAR_SECTION_STATE, SIDEBAR_COLLAPSED } from './Sidebar.constants'

const getStoredObject = (key) => {
  try {
    const stored = JSON.parse(localStorage.getItem(key))

    return isPlainObject(stored) ? stored : {}
  } catch (error) {
    return {}
  }
}

export const getStoredSectionState = () => getStoredObject(SIDEBAR_SECTION_STATE)

export const setStoredSectionState = (sectionState) => {
  localStorage.setItem(SIDEBAR_SECTION_STATE, JSON.stringify(sectionState))
}

export const getStoredSidebarCollapsed = () => {
  try {
    return JSON.parse(localStorage.getItem(SIDEBAR_COLLAPSED)) === true
  } catch (error) {
    return false
  }
}

export const setStoredSidebarCollapsed = (collapsed) => {
  localStorage.setItem(SIDEBAR_COLLAPSED, JSON.stringify(collapsed))
}
